import { useEffect, useMemo, RefObject } from 'react'

const useMutationObserver = ({
  target,
  options = {},
  callback
}: {
  target?: RefObject<any>
  options?: MutationObserverInit
  callback?: MutationCallback
}): void => {
  const observer = useMemo(
    () =>
      new MutationObserver((mutationRecord, mutationObserver) => {
        callback?.(mutationRecord, mutationObserver)
      }),
    [callback]
  )

  useEffect(() => {
    const element = target?.current

    if (observer && element) {
      observer.observe(element, options)

      return () => observer.disconnect()
    }
  }, [target, observer, options])
}

export default useMutationObserver
